/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./itemCard.vue?vue&type=template&id=524f483c&scoped=true&"
import script from "./itemCard.vue?vue&type=script&lang=js&"
export * from "./itemCard.vue?vue&type=script&lang=js&"
import style0 from "./itemCard.vue?vue&type=style&index=0&id=524f483c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_webpack@5.89.0__lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f483c",
  null
  
)

export default component.exports